package features.timeoff.handlers

import kotlinx.browser.document
import org.w3c.dom.HTMLInputElement
import features.timeoff.data.TimeOffRepository

/**
 * Update the days display when dates change
 */
fun updateTimeOffDays() {
    val startInput = document.getElementById("timeoff-start-input") as? HTMLInputElement
    val endInput = document.getElementById("timeoff-end-input") as? HTMLInputElement
    val daysDisplay = document.getElementById("timeoff-days-display")
    
    val startDate = startInput?.value
    val endDate = endInput?.value
    
    if (startDate.isNullOrBlank() || endDate.isNullOrBlank()) {
        daysDisplay?.innerHTML = "<span class='text-slate-400 text-sm'>Select dates to calculate days</span>"
        return
    }
    
    val days = TimeOffRepository.calculateDays(startDate, endDate)
    
    if (days <= 0) {
        daysDisplay?.innerHTML = "<span class='text-red-400 text-sm font-bold'>⚠️ Invalid date range</span>"
    } else {
        val dayText = if (days == 1) "day" else "days"
        daysDisplay?.innerHTML = "<span class='text-brand-cyan text-lg font-bold'>$days $dayText</span>"
    }
}
